import React from 'react';
import { motion } from 'framer-motion';

interface LoadingSpinnerProps {
  ageGroup: '6-9' | '10-13' | '14+';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ ageGroup }) => {
  const getSpinnerContent = () => {
    if (ageGroup === '6-9') {
      return {
        emoji: '🚀',
        text: 'Loading awesome stories...',
        colors: 'from-yellow-400 to-orange-400'
      };
    } else if (ageGroup === '10-13') {
      return {
        emoji: '📚',
        text: 'Getting your articles...',
        colors: 'from-blue-400 to-cyan-400'
      };
    }
    return {
      emoji: '📰',
      text: 'Loading articles...',
      colors: 'from-indigo-400 to-purple-400'
    };
  };

  const content = getSpinnerContent();

  return (
    <div className="flex flex-col items-center justify-center py-16">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        className="text-6xl mb-4"
      >
        {content.emoji}
      </motion.div>
      <div className="relative">
        <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${content.colors} animate-spin`}>
          <div className="absolute inset-2 bg-white rounded-full"></div>
        </div>
      </div>
      <p className="mt-4 text-gray-600 font-medium">{content.text}</p>
    </div>
  );
};

export default LoadingSpinner;